import { Pipe, PipeTransform } from "@angular/core";
import dayjs from "dayjs";

@Pipe({ name: "biDayJs", standalone: true })
export class BiDayJsPipe implements PipeTransform {
  public transform(date: string, dateFormat: string): string {
    // Default format if no Date is present..
    if (date === "0001-01-01T00:00:00Z") {
      return "";
    } else {
      const dateMoment = dayjs(date);
      return dateMoment.isValid() ? dateMoment.format(dateFormat) : "";
    }
  }
}
